import * as React from 'react';
import { Path } from 'react-native-svg';
import { Icon, IIconProps } from 'native-base';

const SvgTimeCircle = (props: IIconProps) => {
  return (
    <Icon viewBox="0 0 20 20" {...props}>
      <Path d="M10 1.25a8.75 8.75 0 10.001 17.501A8.75 8.75 0 0010 1.25zm0 16.016A7.267 7.267 0 012.734 10 7.267 7.267 0 0110 2.734a7.267 7.267 0 010 14.531z" />
      <Path d="M13.412 12.473l-2.785-2.014V5.625a.157.157 0 00-.156-.156h-.94a.157.157 0 00-.156.156v5.379c0 .05.023.098.064.127l3.23 2.355c.071.051.169.035.22-.033l.558-.762a.156.156 0 00-.035-.218z" />
    </Icon>
  );
};

export default SvgTimeCircle;
